export function getBadgeState(snapshot, input) {
  if (!snapshot || snapshot.version !== 1 || snapshot.currency !== 'USD' || snapshot.hasNextPage !== false || !Array.isArray(snapshot.catalog)) return null;
  if (input.country !== 'US' || !['guest','nonmember','eligible','locked'].includes(snapshot.status)) return null;
  if (input.taggedMember && ['guest','nonmember'].includes(snapshot.status)) return null;
  const member = ['eligible','locked'].includes(snapshot.status);
  if (!member && input.enrollmentAvailable !== true) return null;
  if (member && (snapshot.entitlement !== 10 || !snapshot.cycleId || !snapshot.revision || !Array.isArray(snapshot.selections))) return null;
  const product = snapshot.catalog.find(item => String(item.id).split('/').pop() === String(input.productId));
  if (!product || !Array.isArray(product.variants)) return null;
  const available = product.variants.some(variant => Number.isInteger(variant.availableQuantity) && variant.availableQuantity > 0 && input.variantIds.includes(String(variant.id).split('/').pop()));
  if (!available) return null;
  return snapshot.status === 'eligible' ? 'active' : snapshot.status === 'locked' ? 'locked' : 'guest';
}

const instances = new Set();
let pending = null;
let snapshot = null;
let fetchedAt = 0;
let refreshQueued = false;

function queueRefresh() {
  if (refreshQueued) return;
  refreshQueued = true;
  queueMicrotask(() => {refreshQueued = false; refresh();});
}

function loadSnapshot(force = false) {
  if (pending) return pending;
  if (!force && fetchedAt && Date.now() - fetchedAt < 60000) return Promise.resolve(snapshot);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 8000);
  pending = fetch('/apps/fiive-extra-gifts', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal})
    .then(response => {
      if (!response.ok) throw new Error('membership_unavailable');
      return response.json();
    })
    .then(data => {snapshot = data; fetchedAt = Date.now(); return data;})
    .catch(() => {snapshot = null; fetchedAt = Date.now(); return null;})
    .finally(() => {clearTimeout(timeout); pending = null;});
  return pending;
}

function refresh(force = false) {
  if (!instances.size) return;
  loadSnapshot(force).then(data => {
    for (const instance of instances) instance.update(data);
  });
}

if (typeof window !== 'undefined' && !customElements.get('fiive-extra-card-badge')) {
  class FiiveExtraCardBadge extends HTMLElement {
    connectedCallback() {
      instances.add(this);
      queueRefresh();
    }
    disconnectedCallback() {
      instances.delete(this);
    }
    update(data) {
      let enrollment = null;
      try {enrollment = JSON.parse(document.getElementById('fiive-extra-enrollment-config')?.textContent || 'null');} catch {}
      const state = getBadgeState(data, {
        country:this.dataset.country,
        productId:this.dataset.productId,
        variantIds:this.dataset.variantIds.split('|'),
        taggedMember:this.dataset.taggedMember === 'true',
        enrollmentAvailable:enrollment?.available === true
      });
      const card = this.closest('[data-fp-dynamic-card]');
      const link = this.querySelector('.fp-dc-extra__link');
      const shipping = this.querySelector('.fp-dc-extra__shipping');
      card?.setAttribute('data-fp-extra-qualified', state ? 'true' : 'false');
      this.dataset.memberState = state || 'unavailable';
      const local = this.dataset.local === 'true';
      link.hidden = !state && !local;
      if (shipping) shipping.hidden = !state;
      if (!state) {
        if (local) {
          this.querySelector('.fp-dc-extra__benefit').textContent = this.dataset.localCopy;
          link.setAttribute('aria-label', this.dataset.localLabel);
          link.title = this.dataset.localDescription;
        }
        return;
      }
      link.title = this.dataset.description;
      const benefit = this.querySelector('.fp-dc-extra__benefit');
      const copy = this.dataset[state+'Copy'];
      if (benefit.textContent !== copy) benefit.textContent = copy;
      link.setAttribute('aria-label', this.dataset[state+'Label']);
    }
  }
  customElements.define('fiive-extra-card-badge', FiiveExtraCardBadge);
  window.addEventListener('pageshow', event => {if (event.persisted) refresh(true);});
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && Date.now() - fetchedAt >= 60000) refresh(true);
  });
}

